import * as React from "react";
import { SVGProps } from "react";

const Myriad = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 507 507" {...props}>
    <path
      fill="#0f6089"
      d="M506.93 248.42c.05 1.72.07 3.41.07 5.12a252.28 252.28 0 0 1-28.36 116.61l-138.22 55.78.28-.63z"
    />
    <path
      fill="#078fa4"
      d="M506.93 248.36 340.73 425.3l154.39-248.66a252.17 252.17 0 0 1 11.81 71.72z"
    />
    <path
      fill="#00aaa6"
      d="M495.12 176.64 340.73 425.3l-.42.67-18.51-321.79 155.22 58.08 18.1 14.38z"
    />
    <path
      fill="#00aaa6"
      d="m495.12 176.64-18.1-14.38 15.14 5.65c1.06 2.89 2.06 5.81 2.96 8.73z"
    />
    <path fill="#cd1685" d="M492.16 167.91z" />
    <path
      fill="#1eaae2"
      d="m492.16 167.91-149.6-151.8a253.92 253.92 0 0 1 149.6 151.8zm-149.6-151.8 149.6 151.8-15.14-5.65L334.74 49.24l7.8-33.13h.02z"
    />
    <path
      fill="#0c7392"
      d="m340.42 425.93 138.2-55.82A253.72 253.72 0 0 1 305.8 501.58l33.17-72.44z"
    />
    <path
      fill="#1eaae2"
      d="M477.02 162.26 321.8 104.18l12.94-54.94 142.28 113.02z"
    />
    <path
      fill="#abcf3a"
      d="m342.54 16.11-7.81 33.13-61-48.43a250.09 250.09 0 0 1 68.81 15.3z"
    />
    <path fill="#cd1685" d="m340.31 425.97.42-.67-.28.63-.14.04z" />
    <path
      fill="#8f9990"
      d="m340.45 425.93-1.48 3.21-179.23-130.75 2.32-2.06L321.8 104.18l18.51 321.79.14-.04z"
    />
    <path
      fill="#cd1685"
      d="m338.97 429.14-33.17 72.44a252.22 252.22 0 0 1-52.27 5.42c-7 0-13.85-.28-20.65-.83L75.19 369.07l4.59 1z"
    />
    <path
      fill="#ec1076"
      d="M338.97 429.14 79.78 370.11l79.96-71.72 179.23 130.75z"
    />
    <path fill="#abcf3a" d="m334.74 49.24-12.94 54.94L273.73.81l61.01 48.43z" />
    <path
      fill="#e0e224"
      d="m273.73.81 48.06 103.37-176.52-80A252.42 252.42 0 0 1 253.5 0c6.81 0 13.54.28 20.23.81z"
    />
    <path
      fill="#f9a516"
      d="M321.8 104.18 162.06 296.33 92.6 210.67l229.2-106.49z"
    />
    <path
      fill="#fdcd11"
      d="M321.8 104.18 92.6 210.67l52.67-186.45 176.53 79.96z"
    />
    <path fill="#cd1685" d="m233.82 507-1.71-.9.74.07z" />
    <path
      fill="#b9204a"
      d="m75.19 369.07 157.66 137.1-.74-.07-175.39-92.79 17.36-45.22zm-18.47 44.24 175.39 92.79a252.93 252.93 0 0 1-175.39-92.79z"
    />
    <path
      fill="#f05b28"
      d="m92.6 210.67 69.46 85.66-2.32 2.06-122.91-2.59 55.77-85.13z"
    />
    <path
      fill="#f05b28"
      d="m159.74 298.39-79.96 71.72-42.95-74.31 122.91 2.59z"
    />
    <path
      fill="#fdcd11"
      d="M145.27 24.21 92.6 210.67 36.83 295.8l.21-1.79L.42 239.63C5.51 144.25 63.34 62.92 145.27 24.21z"
    />
    <path
      fill="#ab1f25"
      d="m36.83 295.8 42.95 74.31-4.59-1.04-38.36-73.27zm38.36 73.27-1.11-1-17.36 45.24a253.25 253.25 0 0 1-28.36-43.2l8.47-74.29z"
    />
    <path
      fill="#cb0010"
      d="m.37 239.63 36.67 54.38-.21 1.79-8.47 74.29L.37 239.63z"
    />
    <path
      fill="#cb0010"
      d="m.42 239.63 28 130.46A252.23 252.23 0 0 1 0 253.5c0-4.65.11-9.26.42-13.87z"
    />
    <path
      fill="#fff"
      d="m395.88 296.33 11.54-48.62a117.59 117.59 0 0 0 7-41.08 36.82 36.82 0 0 0-9.84-25.05l-1.72-1.85c-11.82-12.74-33-20-50.42-20h-6.09a62.46 62.46 0 0 0-42.54 16.69l-14.39 13.41-2.46-5.64a26.58 26.58 0 0 0-5.35-8 63 63 0 0 0-44.91-18.77 63.1 63.1 0 0 0-35 10.59l-14.18 10.25v-1a17.56 17.56 0 0 0-17.56-17.55H16.2L2.31 210.67l127.33 2.32-18.71 100.56c-3.18 13.69 5.49 27.18 19.49 28.87a23.12 23.12 0 0 0 25-16.3l34.83-107.6c3.76-12.55 20.7-20.53 33.7-18.83a26.73 26.73 0 0 1 22.26 33.8l-18.34 79.93a28.42 28.42 0 0 0 27.35 36.18c12.13 0 18.3-7.69 22.25-19.16l34.95-103.89c4.06-11.77 18.46-18.78 30.7-16.45a25.06 25.06 0 0 1 19.3 31.82l-18.54 68.21a30.52 30.52 0 0 0 29.19 39.44l119.72-2.31 13.89-50.93z"
    />
  </svg>
);

export default Myriad;
